import http from '@/services/rest/rest.service';

import {IPreferredDomain, IPreferredDomainView} from '@/entities/preferred-domains';
import {IOfficeDetail, IOfficeEdit, ISite, IUpdateSiteStatus} from '@/entities';
import {IUpdatePreferredDomainHidden} from '@/entities/preferred-domains/update-preferred-domain-hidden';

export default {
  list(): Promise<IPreferredDomain[]> {
    let url = 'preferredDomains/list';
    return http.get(url);
  },
  listWithCompanyName(): Promise<IPreferredDomain[]> {
    let url = 'preferredDomains/listWithCompanyName';
    return http.get(url);
  },
  listWithCompanies(): Promise<IPreferredDomainView[]> {
    let url = 'preferredDomains/listWithCompanies';
    return http.get(url);
  },
  updateStatusBatch(ids, model: IUpdatePreferredDomainHidden): Promise<IPreferredDomain[]> {
    return http.post(`preferredDomains/hidden`, {ids, ...model});
  },
  get(id: number): Promise<IPreferredDomain> {
    return http.get(`preferredDomains/${id}`);
  },
  create(model: IPreferredDomain): Promise<number> {
    return http.put(`preferredDomains`, model);
  },
  update(id: number, model: IPreferredDomain): Promise<number> {
    return http.post(`preferredDomains/${id}`, model);
  },
};
